import { useEffect, useState } from "react";
import { _CompetitionType, _Entailment, _MacroProcess, _SubMacroProcess } from "../../../../core/services/dataBean/EntityCatalog";

import { Singleton } from "../../../../core/services/Singleton";
import { toast } from "react-toastify";
import { ListMenu } from "../../../theme/Component/ListMenu";
import { BasicPage } from "../../../theme/Component/BasicPage";
import { BasicTable, MASK_BOOLEAN_ICON, MASK_NUMBER } from "../../../theme/Component/BasicTable";
import { Modal } from "../../../theme/Component/Modal";
import { ModalConfirm } from "../../../theme/Component/ModalConfirm";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { PrintJson } from "../../../theme/Component/PrintJson";
import { PrintObjectJson } from "../../../theme/Component/PrintObjectJson";
import { _PaymentAccount } from "../../../../core/services/dataBean/EntityCatalogVdos";
import { SelectAccountantTree } from "../../../contabilidad/catalogo-cuentas/AccountantTree/SelectAccountantTree";
import { SelectBudgetID } from "../../../admin/configuracion/BudgetID/SelectBudgetID";
import { BasicSwitch } from "../../../theme/Component/BasicSwitch";

interface Props {
    IDPaymentAccount: number;
}

export const PaymentAccountItem = ({ IDPaymentAccount }: Props) => {

    const PaymentAccountItem = useDataBean(_PaymentAccount);


    const single = Singleton.getInstance();

    const [lista, setLista] = useState<any>([]);
    const [modalvalue, setModalvalue] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });
    const [modal, setModal] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });
    const [modalC, setModalC] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });

    useEffect(() => {
        getLista();
    }, [IDPaymentAccount])

    const getLista = () => {

        PaymentAccountItem.instance.getPaymentAccountItemByPaymentAccount(IDPaymentAccount).then(
            (resp: any) => {
                if (resp) {
                    setLista(resp)
                    //console.log(resp)
                }
            }
        )

    }

    const setPaymentAccountItemValue = () => {

        PaymentAccountItem.instance.setPaymentAccountItemValue(PaymentAccountItem.bean.IDPaymentAccountItem, PaymentAccountItem.bean.Value).then(
            (resp: any) => {
                if (resp) {
                    toast.success('Actualizado');
                    setModalvalue({ ...modalvalue, "view": false });
                    getLista()
                }
            }
        ).catch(err => {
            toast.error(err);
        })

    }

    const deleteItem = () => {
        PaymentAccountItem.deleteItemVoid(PaymentAccountItem.bean.IDPaymentAccountItem).then(
            (resp: any) => {
                getLista();
                setModalC({ ...modalC, "view": false });
            }
        )

    }


    const create = () => {
        PaymentAccountItem.setBean({
            IDPaymentAccount: IDPaymentAccount
        });
        setModal({ ...modal, "view": true });
    }

    const editaItem = () => {
        ////console.log(SubMacroProcess.bean);
        PaymentAccountItem.update().then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }

    const head = [
        { title: 'ID', property: 'IDPaymentAccountItem', visible: true, mask: MASK_NUMBER },

        { title: 'Cuenta Contable', property: 'AccountantIDName', visible: true },
        { title: 'Rubro Presupuestal', property: 'BudgetName', visible: true },
        { title: 'Recurso Presupuestal', property: 'BudgetResourceName', visible: true },
        { title: 'Fuente de Financiamiento', property: 'BudgetSourceName', visible: true },
        { title: 'Código', property: 'CodeID', visible: true },
        { title: 'Concepto', property: 'ConceptID', visible: true },
        // , mask: MASK_BOOLEAN_ICON
        { title: 'Cuenta Consolida Tercero', property: 'RequiresConsolidateThird', visible: true },
        { title: 'Valor', property: 'Value', visible: true },
        { title: 'Cantidad Terceros', property: 'AccountsQuantity', visible: true },

    ]

    // const iconButtonsItem = [
    //     { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    // ]
    const listaBotones = () => {
        const botones = [

            { titulo: 'Valor del elemento de la cuenta de pago', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModalvalue({ ...modalvalue, "view": true }) } },
            // { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }
    return (
        <div className="row">
            <div className="col-md-12">
                <BasicTable body={lista} head={head} rowSet={PaymentAccountItem.setBean} listButtons={listaBotones()} ></BasicTable>
                <Modal modal={modal} updateModal={setModal} eventModal={editaItem}>
                    <div className="row">
                        <div className="col-md-6">
                            <SelectAccountantTree
                                label="Cuenta Contable"
                                jsonCode={PaymentAccountItem.bean.AccountantID}
                                onChange={(e) => {
                                    PaymentAccountItem.setBean({ ...PaymentAccountItem.bean, "AccountantID": e.JsonCode });
                                }}
                            />
                        </div>

                        <div className="col-md-6">
                            <SelectBudgetID label='Rubro Presupuestal' edit={false} tipoPresupuesto={0} idBudgetID={PaymentAccountItem.bean.BudgetID} onChange={(e) => {
                                PaymentAccountItem.setBean({
                                    ...PaymentAccountItem.bean,
                                    "BudgetID": e.IDLn
                                });
                            }} />
                        </div>
                        <div className="col-md-6">
                            <SelectBudgetID label='Recurso Presupuestal' edit={false} tipoPresupuesto={0} idBudgetID={PaymentAccountItem.bean.IDBudgetResource} onChange={(e) => {
                                PaymentAccountItem.setBean({
                                    ...PaymentAccountItem.bean,
                                    "IDBudgetResource": e.IDLn
                                });
                            }} />
                        </div>
                        <div className="col-md-6">
                            <SelectBudgetID label='Fuente de Financiamiento' edit={false} tipoPresupuesto={0} idBudgetID={PaymentAccountItem.bean.IDBudgetSource} onChange={(e) => {
                                PaymentAccountItem.setBean({
                                    ...PaymentAccountItem.bean,
                                    "IDBudgetSource": e.IDLn
                                });
                            }} />
                        </div>
                        <div className="col-md-6">
                            <div className="col-md-12">
                                <label>Código:</label>
                                <input type="text" name="CodeID" className="form-control" value={PaymentAccountItem.bean.CodeID} onChange={PaymentAccountItem.handleChange} />
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="col-md-12">
                                <label>Concepto:</label>
                                <input type="text" name="ConceptID" className="form-control" value={PaymentAccountItem.bean.ConceptID} onChange={PaymentAccountItem.handleChange} />
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="col-md-12">
                                {/* <label>Cuenta Consolida Tercero:</label> */}
                                <BasicSwitch label="Cuenta Consolida Tercero:" estado={PaymentAccountItem.bean.RequiresConsolidateThird} eventChange={(e) => { PaymentAccountItem.setBean({ ...PaymentAccountItem.bean, "RequiresConsolidateThird": e }) }}></BasicSwitch>
                                {/* <input type="text" name="RequiresConsolidateThird" className="form-control" value={PaymentAccountItem.bean.RequiresConsolidateThird} onChange={PaymentAccountItem.handleChange} /> */}
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="col-md-12">
                                <label>Valor:</label>
                                <input type="text" name="Value" className="form-control" value={PaymentAccountItem.bean.Value} onChange={PaymentAccountItem.handleChange} />
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="col-md-12">
                                <label>Cantidad Terceros:</label>
                                <input type="number" name="AccountsQuantity" className="form-control" value={PaymentAccountItem.bean.AccountsQuantity} onChange={PaymentAccountItem.handleChange} />
                            </div>
                        </div>

                    </div>
                </Modal>
                <Modal modal={modalvalue} updateModal={setModalvalue} eventModal={setPaymentAccountItemValue}>
                    <div className="row">
                        <div className="col-md-12">
                            <label> Valor Item</label>
                            <input type="number" name="Value" className="form-control" value={PaymentAccountItem.bean.Value} onChange={(e) => { PaymentAccountItem.setBean({ ...PaymentAccountItem.bean, "Value": parseFloat(e.target.value) }) }} />
                        </div>
                    </div>
                </Modal>
                <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                    <strong>Eliminar item</strong>
                </ModalConfirm>
            </div>

        </div>
    )
}